import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishProfileReplaceConfirmDialog',
  props: {
    value: { type: Boolean }
  },
  emits: ["input", "replace", "append"],
  setup(__props: any) {





return { __sfc: true, }
}

})